import React from 'react';

import Radio from './Radio';
import SelectWidget from './SelectWidget';

const QuestionCount = ({ index, total }) => {
  const count = total - index - 1;
  const questionText = count > 1 ? 'questions' : 'question';

  const output =
    count > 0 ? `${count} ${questionText} left` : `Last ${questionText}`;

  if (count != total - 1) {
    return <div className="split-section__count">{output}</div>;
  } else {
    return null;
  }
};

const SlideSection = ({
  options,
  type,
  title,
  image,
  results_key,
  slideIndex,
  fullpageApi,
  description,
  totalSlides,
}) => {
  return (
    <div className={`section fullpage-slides section--key-${results_key}`}>
      <div className="split-section split-section--slide text-align-left">
        <div className="split-section__first">
          <div className="split-section__first-wrapper">
            <QuestionCount index={slideIndex} total={totalSlides} />
            <h2 className="split-section__title">{title}</h2>
            {description && (
              <div
                className="split-section__help-text"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
            <div className="split-section__form">
              {type === 'radio' && (
                <Radio
                  options={options}
                  slideIndex={slideIndex}
                  results_key={results_key}
                  fullpageApi={fullpageApi}
                  slideIndex={slideIndex}
                />
              )}
              {type === 'multiselect' && (
                <SelectWidget
                  fullpageApi={fullpageApi}
                  options={options}
                  results_key={results_key}
                  hasMulti={true}
                  slideIndex={slideIndex}
                />
              )}
              {type === 'select' && (
                <SelectWidget
                  fullpageApi={fullpageApi}
                  options={options}
                  results_key={results_key}
                  hasMulti={false}
                  slideIndex={slideIndex}
                />
              )}
            </div>
          </div>
        </div>
        <div className="split-section__second">
          <div
            className="split-section__image"
            style={{ backgroundImage: `url(${image})` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default SlideSection;
